var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6H81C88.1797 6 94 11.8203 94 19V81C94 88.1797 88.1797 94 81 94H19C11.8203 94 6 88.1797 6 81V19C6 11.8203 11.8203 6 19 6ZM0 19C0 8.50659 8.50659 0 19 0H81C91.4934 0 100 8.50659 100 19V81C100 91.4934 91.4934 100 81 100H19C8.50659 100 0 91.4934 0 81V19ZM20 33H80.5V25H20V33ZM80.5 54H20V46H80.5V54ZM20 75H80.5V67H20V75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhite);
export default __webpack_public_path__ + "static/media/menu_white.4cf2c2a40c98b281a25881e292b49b4b.svg";
export { ForwardRef as ReactComponent };